import React from 'react';
import PropTypes from 'prop-types';
import { Button, Header, Table } from 'semantic-ui-react';
import _ from 'lodash';

const wrapperStyles = {
  marginBottom: 30,
};

const pStyles = {
  textAlign: 'center',
  margin: '20px 0px',
  padding: '20px 0px',
  borderTop: 'solid 1px #d8d8d8',
  borderBottom: 'solid 1px #d8d8d8',
};

const buttonOptions = {
  joined: {
    color: 'black',
    text: 'joined',
  },
  pending: {
    color: 'grey',
    text: 'pending...',
  },
};

const getInvitationButton = invitation => {
  const options = (invitation.type === 'campaignPermission')
    ? buttonOptions.joined
    : buttonOptions.pending;

  return (
    <Button fluid basic disabled color={options.color}>{options.text}</Button>
  );
};

const getDeleteButton = (invitation, deleteHandler) => (
  <Button
    inverted
    onClick={() => deleteHandler(invitation)}
    circular
    color="red"
    size="tiny"
  >
    x
  </Button>
);
const emptyTable = () => (
  <div style={wrapperStyles}>
    <Header as="h3" textAlign="center">Added</Header>
    <div style={pStyles}>
      <p>You haven&apos;t added anyone yet.</p>
    </div>
  </div>
);

const emptySubTable = text => (
  <div style={wrapperStyles}>
    <div style={pStyles}>
      <p>You haven&apos;t added {text} yet.</p>
    </div>
  </div>
);

const tableRow = (i, deleteHandler, discussionNames) => {
  const discussionExists = _.includes(discussionNames, i.metadata.socialHandle);
  const warningStyle = discussionExists ? {} : { backgroundColor: 'red' };
  return (
    <Table.Row key={i.id} style={warningStyle}>
      <Table.Cell>{i.name}&nbsp;
        {i.role === 'INFLUENCER' ? `(${i.metadata.socialHandle})` : ''}
      </Table.Cell>
      <Table.Cell>
        {i.role}
      </Table.Cell>
      <Table.Cell textAlign="center">
        {i.email}
      </Table.Cell>
      <Table.Cell collapsing>
        { getInvitationButton(i) }
      </Table.Cell>
      <Table.Cell collapsing>
        { getDeleteButton(i, deleteHandler) }
      </Table.Cell>
    </Table.Row>
  );
};

const getTable = (people, deleteHandler, discussions) => {
  const discussionNames = _.map(discussions, 'name');
  return (
    <Table>
      <Table.Body>
        {
          _.map(people, i => (
            tableRow(i, deleteHandler, discussionNames)
          ))
        }
      </Table.Body>
    </Table>
  );
};

const InvitedTable = ({ campaign, deleteHandler }) => {
  if (!campaign) {
    return emptyTable();
  }

  const combinedArrays = _.concat(campaign.members, campaign.pendingInvitations);
  const { discussions } = campaign;
  if (_.isEmpty(combinedArrays)) {
    return emptyTable('anyone');
  }

  const influencers = _.filter(combinedArrays, { role: 'INFLUENCER' });
  const team = _.filter(combinedArrays, { role: 'TEAM_MEMBER' });

  return (
    <div style={wrapperStyles}>
      <Header as="h3" textAlign="center">Added</Header>
      <Header as="h4">INFLUENCERS ({influencers.length})</Header>
      {
        _.isEmpty(influencers)
          ? emptySubTable('any influencers')
          : getTable(influencers, deleteHandler, discussions)
      }
      <br />
      <Header as="h4">TEAM MEMBERS</Header>
      {
        _.isEmpty(team)
          ? emptySubTable('any team members')
          : getTable(team)
      }
    </div>
  );
};

InvitedTable.propTypes = {
  campaign: PropTypes.object.isRequired,
  deleteHandler: PropTypes.func.isRequired,
};

export default InvitedTable;



/** WEBPACK FOOTER **
 ** ./src/components/invited-table/index.js
 **/